(function () {
  'use strict';

  var mega = document.querySelector('[data-yc-mega]');
  if (!mega) return;

  var label = (mega.getAttribute('data-trigger-label') || 'Shop').trim().toLowerCase();
  var closeTimer = null;
  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 160;

  // ---- locate the header "Shop" trigger ----
  var triggerLi = null;
  var triggerLink = null;
  var navItems = document.querySelectorAll('.header__menu-item, .header__inline-menu a, .header__inline-menu summary');
  navItems.forEach(function (el) {
    if (triggerLi) return;
    var txt = (el.textContent || '').trim().toLowerCase();
    if (txt === label) {
      triggerLink = el;
      triggerLi = el.closest('li') || el;
    }
  });

  function positionPanel() {
    var header = document.querySelector('.header-wrapper') || document.querySelector('.header');
    if (header) {
      var rect = header.getBoundingClientRect();
      mega.style.setProperty('--yc-mega-top', Math.max(rect.bottom, 0) + 'px');
    }
  }

  function open() {
    clearTimeout(closeTimer);
    positionPanel();
    mega.classList.add('is-open');
    mega.setAttribute('aria-hidden', 'false');
    if (triggerLink) triggerLink.setAttribute('aria-expanded', 'true');
  }

  function close() {
    mega.classList.remove('is-open');
    mega.setAttribute('aria-hidden', 'true');
    if (triggerLink) triggerLink.setAttribute('aria-expanded', 'false');
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, CLOSE_DELAY);
  }

  function scheduleOpen() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(open, OPEN_DELAY);
  }

  // ---- desktop hover intent ----
  if (triggerLi) {
    // Neutralize Dawn's native <details> dropdown if the Shop item has one
    var dawnDetails = triggerLi.querySelector('details');
    if (dawnDetails) {
      dawnDetails.addEventListener('toggle', function () {
        if (dawnDetails.open) dawnDetails.open = false;
      });
    }

    triggerLi.addEventListener('mouseenter', scheduleOpen);
    triggerLi.addEventListener('mouseleave', scheduleClose);

    // keyboard: open on focus, close on blur-out
    triggerLi.addEventListener('focusin', open);
    triggerLi.addEventListener('focusout', function (e) {
      if (!triggerLi.contains(e.relatedTarget) && !mega.contains(e.relatedTarget)) scheduleClose();
    });
  }

  // keep open while pointer is on the panel
  mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
  mega.addEventListener('mouseleave', scheduleClose);

  // link tap inside panel closes it
  mega.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', close);
  });

  // Escape closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && mega.classList.contains('is-open')) close();
  });

  // reposition on resize/scroll while open
  window.addEventListener('resize', function () { if (mega.classList.contains('is-open')) positionPanel(); });
  window.addEventListener('scroll', function () { if (mega.classList.contains('is-open')) positionPanel(); }, { passive: true });

  // ---- mobile: floating Shop icon opens the panel instead of navigating ----
  var floatShop = document.querySelector('.yc-mnav a[aria-label="Shop"]');
  if (floatShop) {
    floatShop.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 749px)').matches) {
        e.preventDefault();
        if (mega.classList.contains('is-open')) {
          close();
        } else {
          mega.classList.add('yc-mega--mobile');
          open();
        }
      }
    });
  }

  // tapping the dim area (mobile full-screen) closes
  mega.addEventListener('click', function (e) {
    if (e.target === mega && mega.classList.contains('yc-mega--mobile')) close();
  });
})();
